__turbopack_context__.v({
  "art": "landing-banner-module-scss-module__-068rq__art",
  "banner": "landing-banner-module-scss-module__-068rq__banner",
  "content": "landing-banner-module-scss-module__-068rq__content",
  "description": "landing-banner-module-scss-module__-068rq__description",
  "inner": "landing-banner-module-scss-module__-068rq__inner",
  "title": "landing-banner-module-scss-module__-068rq__title",
  "title-highlight": "landing-banner-module-scss-module__-068rq__title-highlight",
});
